import React, { memo, useEffect } from 'react';
import { Typography } from 'antd';
import { useAppStore } from '../../../common/store';
import { DocgenClient } from '../../../data/docgenClient';
import { handleErrorWithServerMessage } from '../../../data/errorHandler';
import { t } from '../../../utils';
import { CustomFileUploader } from '../CustomFileUploader';
import { UploadPreview } from '../UploadPreview';
import { ProgressState } from './types';

const { Title } = Typography;

export const SelectDocument = memo(() => {
	const {
		documentTemplate,
		resetUrlSliceData,
		thumbnailUrl,
		fetchThumbnailUrl,
		resetComponentSliceData,
		updateDocumentTemplate,
	} = useAppStore(state => ({
		documentTemplate: state.documentTemplate,
		thumbnailUrl: state.thumbnailUrl,
		downloadUrl: state.downloadUrl,
		fetchThumbnailUrl: state.fetchThumbnailUrl,
		resetUrlSliceData: state.resetUrlSliceData,
		resetComponentSliceData: state.resetComponentSliceData,
		updateDocumentTemplate: state.updateDocumentTemplate,
	}));

	const [uploadState, setUploadState] = React.useState<ProgressState>('');

	useEffect(() => {
		if (thumbnailUrl) {
			setUploadState('ready');
		}
		// Required to handle edit template
		const getThumbnail = () => {
			if (
				documentTemplate?.file?.fileName &&
				!thumbnailUrl &&
				documentTemplate?.status !== 'Draft'
			) {
				setUploadState('downloading');
				fetchThumbnailUrl(documentTemplate.rid);
				setUploadState('ready');
			}
		};
		getThumbnail();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [documentTemplate?.file?.fileName]);

	const [isRemoveFileDisabled, setIsRemoveFileDisabled] = React.useState(false);

	const resetUploadState = () => {
		setUploadState('');
		resetUrlSliceData();
		resetComponentSliceData();
		updateDocumentTemplate({ file: null });
	};
	const deleteUploadedFile = () => {
		try {
			DocgenClient.deleteUploadedFile(documentTemplate.rid);
		} catch {
			handleErrorWithServerMessage(t('errorMessages.deleteUploadedFileError'));
		}
	};

	const resetUpload = () => {
		resetUploadState();
		deleteUploadedFile();
	};

	return (
		<div style={{ marginTop: '15px' }}>
			<Title level={4}>{t('documentToSend')}</Title>
			{uploadState && (
				<UploadPreview
					uploadState={uploadState}
					resetUpload={resetUpload}
					isRemoveFileDisabled={isRemoveFileDisabled}
					setIsRemoveFileDisabled={setIsRemoveFileDisabled}
				/>
			)}

			{!uploadState && (
				<CustomFileUploader
					setUploadState={setUploadState}
					resetUploadState={resetUploadState}
				/>
			)}
		</div>
	);
});
